import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BrowserModule } from '@angular/platform-browser';

import { SidePanelComponent } from './side-panel.component';

@NgModule({
  declarations: [SidePanelComponent],
  exports: [SidePanelComponent],
  imports: [BrowserModule, MatSidenavModule, MatIconModule],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SidePanelModule {}
